export const GridDireita = {
    padding: '0px 10px'
}

export const BlackBox = {
    borderRadius: '7px',
    border: '1px solid black',
    padding: '3px',
    height: 'calc(100% - 15px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-beetwen',
    flexWrap: 'nowrap',
    overflowY: 'scroll',
    overflowX: 'hidden'
}

const GridPlayers = {
    fontSize: '12px',
    height: '33%'
}

export const BoxGridPlayers = {
    height: '100%',
    width: '100%',
    overflow: 'hidden'
}

export const TitleListPlayer = {
    height: '15px'
}

export const GridVideos = {
    ...GridPlayers
}

export const GridFotos = {
    ...GridPlayers
}

export const GridAudios = {
    ...GridPlayers
}

export const FlexRowBeetwen = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-beetwen'
}

export const CameraName = {
    // border: '1px solid blue',
    alignItems: 'center',
    marginLeft: '5px',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}

export const IconSize = {
    fontSize: '20px'
}

export const IconPlay = {
    ...IconSize,
    cursor: 'pointer'
}

export const GridCameraName = {
    // border: '1px solid red',
    maxHeight: '20px',
    display: 'flex',
    alignItens: 'center'
}

export const inputGroupSx = {
    display: 'flex',
    alignItems: 'center',
    padding: 0
}
